import { jsxs, jsx } from 'react/jsx-runtime';
import { Invoice, TruckShipping, Shop } from '@zooplus/icons';
import { useTranslation } from '../../hook/use-translations.js';
import { AddressType } from '../address/types/address-form-types.js';
import styles from './address-heading.module.scss.js';

const AddressHeading = (props) => {
    const { t } = useTranslation();
    const { type } = props;
    const ariaLabel = `${type}AddressTitle`;
    return (jsxs("span", { className: styles.addressHeading, "data-testid": `${type}AddressHeading`, children: [type === AddressType.INVOICE ? (jsx(Invoice, { size: 32, "aria-labelledby": ariaLabel })) : type === AddressType.DELIVERY ? (jsx(TruckShipping, { size: 32, "aria-labelledby": ariaLabel })) : (jsx(Shop, { size: 32, "aria-labelledby": ariaLabel })), type && jsx("span", { id: ariaLabel, children: t(`customer-data.${type}Address.title`) })] }));
};

export { AddressHeading };
//# sourceMappingURL=address-heading.js.map
